export default "__VITE_ASSET__af6ee006__"